import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "动画推荐", to: "/category/recommend" },
      { label: "动漫新闻", to: "/category/news" },
      { label: "角色介绍", to: "/category/characters" },
      { label: "搜索中心", to: "/search" },
    ],
  },
  {
    title: "精选专题",
    links: [
      { label: "星际远征", to: "/special/special-1" },
      { label: "剑与翼", to: "/special/special-2" },
      { label: "治愈时刻", to: "/special/special-3" },
      { label: "时间的形状", to: "/special/special-4" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "内容范围", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "版权声明", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-primary-800">
                <i className="ri-windy-line text-2xl"></i>
              </span>
              <span className="font-display text-xl tracking-wide text-background-50">
                风车动漫网
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              风车动漫网致力于为动漫爱好者提供丰富的动漫资源和最新动漫资讯，涵盖动画推荐、动漫新闻及角色介绍，满足用户全面的动漫需求。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-sm text-background-100/80">
              <i className="ri-mail-line"></i>
              contact@windmill-anime.demo
            </p>
          </div>
          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="mb-4 text-sm font-bold text-background-50">{column.title}</h3>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-background-100/75 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 风车动漫网 Windmill Anime. 本站内容均为虚构示例，仅用于功能演示。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            不含登录、支付、下载与在线播放功能
          </p>
        </div>
      </div>
    </footer>
  );
}